import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Button as LumxButton, FlexBox, Orientation, type ButtonProps, Alignment } from '@lumapps/lumx/react';
import { lightenDarkenColor } from '@lumapps/utils/color';
import { ElementRender } from '@lumapps/wrex/types';

import { BUTTON } from '../../../constants';
import { ButtonElement } from '../../../types';

import './index.scss';

export const CLASSNAME = 'wrex-content-button';

/**
 * Creates a button in a rich text
 */
export const Button: ElementRender<ButtonElement, HTMLDivElement> = (props) => {
    const { children, className, elementRef, element, ...forwardedProps } = props;
    const { backgroundColor, color, label, fullWidth, href } = element || {};
    const { block } = useClassnames(CLASSNAME);
    const linkProps = href
        ? { href, target: '_blank' as ButtonProps['target'], rel: 'noopener noreferrer' }
        : undefined;
    const backgroundColorDarker = backgroundColor && lightenDarkenColor(backgroundColor, -10);
    const backgroundColorDarkest = backgroundColor && lightenDarkenColor(backgroundColor, -20);

    const customStyles = {
        '--lumx-button-emphasis-high-state-default-theme-light-color': color,
        '--lumx-button-emphasis-high-state-hover-theme-light-color': color,
        '--lumx-button-emphasis-high-state-active-theme-light-color': color,
        '--lumx-button-emphasis-high-state-default-theme-light-background-color': backgroundColor,
        '--lumx-button-emphasis-high-state-hover-theme-light-background-color': backgroundColorDarker,
        '--lumx-button-emphasis-high-state-active-theme-light-background-color': backgroundColorDarkest,
    };

    return (
        <FlexBox
            className={block([className])}
            {...forwardedProps}
            orientation={Orientation.horizontal}
            vAlign={Alignment.center}
            fillSpace={fullWidth}
            ref={elementRef}
        >
            <LumxButton {...linkProps} style={customStyles} fullWidth={fullWidth} contentEditable={false}>
                {label}
            </LumxButton>
            {children}
        </FlexBox>
    );
};

Button.displayName = BUTTON;
